import withStyles from "isomorphic-style-loader/withStyles";
import React, { useRef, useState } from "react";
import styles from "../../styles.scss";
import { ClickAwayListener, Tooltip } from "@mui/material";
import { Input } from "reactstrap";
import { HexAlphaColorPicker, HexColorPicker } from "react-colorful";

interface TooltipColorPickerProps {
  value: string;
  setValue: (newValue: string) => void;
  includeAlphaValue?: boolean;
  maxInputWidth?: string;
}

const TooltipColorPicker = ({
  value,
  setValue,
  includeAlphaValue = false,
  maxInputWidth = "100%",
}: TooltipColorPickerProps) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const popperRef = useRef<HTMLDivElement | null>(null);

  const openTooltip = () => setOpen(true);
  const closeTooltip = () => setOpen(false);

  const handleClickAway = (event: MouseEvent | TouchEvent) => {
    if (!open) {
      return;
    }
    const target = event.target as Node;
    if (rootRef.current?.contains(target)) {
      return;
    }
    if (popperRef.current?.contains(target)) {
      return;
    }
    closeTooltip();
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway} mouseEvent="onMouseDown">
      <div ref={rootRef}>
        <Tooltip
          onClose={closeTooltip}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            includeAlphaValue ? (
              <HexAlphaColorPicker color={value} onChange={setValue} />
            ) : (
              <HexColorPicker color={value} onChange={setValue} />
            )
          }
          slotProps={{
            popper: {
              disablePortal: true,
              ref: (node: HTMLDivElement | null) => {
                popperRef.current = node;
              },
            },
          }}
        >
          <div className={styles.colorPicker} onClick={openTooltip}>
            <div className={styles.colorSwatchContainer}>
              <div
                className={styles.colorSwatch}
                style={{ backgroundColor: value }}
              ></div>
            </div>
            <Input
              type="text"
              value={value}
              onChange={e => setValue(e.target.value)}
              className={styles.colorInput}
              onClick={openTooltip}
              style={{ maxWidth: maxInputWidth }}
              maxLength={includeAlphaValue ? 9 : 7}
            />
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default withStyles(styles)(TooltipColorPicker);
